import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Film, TrendingUp, Calendar } from "lucide-react";
import api from "@/lib/api";
import ProgressBar from "@/components/ProgressBar";

export default function RoutesPage() {
  const [routes, setRoutes] = useState([]);
  useEffect(() => {
    api.get("/routes").then((r) => setRoutes(r.data)).catch(() => {});
  }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-testid="routes-page">
      <div className="mb-12">
        <span className="text-[10px] uppercase tracking-[0.3em] text-[#E50914] font-bold">Summertime Saga</span>
        <h1 className="font-display text-4xl sm:text-5xl font-black mt-2">Choose your route</h1>
        <p className="text-zinc-400 mt-2 max-w-2xl">
          Each character has her own storyline, progression, and unlock journey. Pick one and dive in.
        </p>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-5">
        {routes.map((r) => (
          <Link
            key={r.id}
            to={`/routes/${r.id}`}
            data-testid={`route-card-${r.id}`}
            className="group relative rounded-2xl overflow-hidden bg-[#0e0e0e] border border-white/5 hover:border-[#E50914]/40 transition-all hover-glow"
          >
            <div className="relative aspect-[264/507] overflow-hidden bg-[#0e0e0e]">
              <img src={r.character_image} alt={r.name} className="absolute inset-0 w-full h-full object-cover object-center transition-transform duration-700 group-hover:scale-105" />
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-transparent" />
              <div className="absolute top-3 right-3 px-2 py-1 rounded-full bg-black/70 backdrop-blur-md border border-white/10 text-[10px] uppercase tracking-widest font-bold">
                {r.video_count} videos
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-4 space-y-2">
                <div className="flex items-baseline justify-between gap-2">
                  <h3 className="font-display font-black text-xl group-hover:text-[#E50914] transition-colors">{r.name}</h3>
                  <span className="text-[11px] font-bold text-[#32D74B]">{r.progress}%</span>
                </div>
                <ProgressBar value={r.progress} max={100} testid={`route-progress-${r.id}`} />
                <div className="flex items-center justify-between text-[10px] text-zinc-400 pt-0.5">
                  <span className="flex items-center gap-1"><Film className="w-3 h-3" /> {r.video_count}</span>
                  <span className="flex items-center gap-1"><Calendar className="w-3 h-3" /> {r.last_update ? new Date(r.last_update).toLocaleDateString(undefined, { day: "numeric", month: "short" }) : "—"}</span>
                  <span className="flex items-center gap-1 text-[#32D74B]"><TrendingUp className="w-3 h-3" /> {r.progress}%</span>
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
